import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    // Store the previous title
    const prevTitle = document.title;
    
    // Set the new title immediately
    const fullTitle = title === 'Keystone Sign Printing' 
      ? title 
      : `${title} | Keystone Sign Printing`;
    
    document.title = fullTitle;
    
    // Force a title update using a microtask to ensure it happens after React rendering
    queueMicrotask(() => {
      if (document.title !== fullTitle) {
        document.title = fullTitle;
      }
    });
    
    // Cleanup function to restore previous title if needed
    return () => {
      // Only restore if we're unmounting and no new title has been set
      if (document.title === fullTitle) {
        document.title = prevTitle;
      }
    };
  }, [title]);
};